"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvertableSelectStatusBar = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var InvertableSelectLimitWarning_1 = require("./InvertableSelectLimitWarning");
/**
 * @internal
 */
function InvertableSelectStatusBar(props) {
    var className = props.className, selectedItems = props.selectedItems, getItemTitle = props.getItemTitle, isInverted = props.isInverted, selectedItemsLimit = props.selectedItemsLimit;
    var intl = react_intl_1.useIntl();
    var isSelectionEmpty = selectedItems.length === 0;
    var isAll = isSelectionEmpty && isInverted;
    var isNone = isSelectionEmpty && !isInverted;
    var isAllExcept = !isSelectionEmpty && isInverted;
    var selectionString = react_1.useMemo(function () {
        return selectedItems.map(function (selectedItem) { return getItemTitle(selectedItem); }).join(", ");
    }, [selectedItems, getItemTitle]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classnames_1.default([className, "gd-invertable-select-selection-status", "s-list-status-bar"]) },
            react_1.default.createElement("span", null,
                "\u00A0",
                intl.formatMessage({ id: "gs.list.is" }),
                "\u00A0"),
            isAll ? react_1.default.createElement("b", null, intl.formatMessage({ id: "gs.list.all" })) : null,
            isNone ? react_1.default.createElement("b", null, intl.formatMessage({ id: "gs.filterLabel.none" })) : null,
            isAllExcept ? (react_1.default.createElement("span", null,
                react_1.default.createElement("b", null, intl.formatMessage({ id: "gs.list.all" })),
                "\u00A0",
                intl.formatMessage({ id: "gs.list.except" }),
                "\u00A0")) : null,
            !isAll && !isSelectionEmpty ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { className: "gd-shortened-text gd-selection-list s-dropdown-attribute-selection-list", title: selectionString }, selectionString), "\u00A0(" + selectedItems.length + ")")) : null),
        selectedItems.length >= selectedItemsLimit ? (react_1.default.createElement(InvertableSelectLimitWarning_1.InvertableSelectLimitWarning, { limit: selectedItemsLimit, selectedItemsCount: selectedItems.length })) : null));
}
exports.InvertableSelectStatusBar = InvertableSelectStatusBar;
//# sourceMappingURL=InvertableSelectStatusBar.js.map